import moment from "moment";

export const sortByToDate = <T extends { fromDate?: string }>(
  recordA: T,
  recordB: T,
  order: "ASC" | "DESC" = "DESC"
): 1 | -1 | 0 => {
  if (!recordA.fromDate || !recordB.fromDate) {
    return 0;
  }
  const isErlier = moment(recordA.fromDate).isBefore(moment(recordB.fromDate));
  if (order === "DESC") {
    return isErlier ? 1 : -1;
  }
  return isErlier ? -1 : 1;
};
